// extracted by mini-css-extract-plugin
export default {"loading":"loading-iCuAj","loader":"loader-Kso6C","outerLoader":"outerLoader-Xn1Yh","spin":"spin-PAY97","innerSpin":"innerSpin-ezWtA"};